import { createSlice } from '@reduxjs/toolkit';
import { defaultOffset, defaultPageSize } from 'appConfig';
import { AppDispatch } from 'redux/store';
import { ANNOUNCEMENTS, Announcements, AnnouncementsTabs } from 'types/announcements';
import { Baskets, BasketsTabs } from 'types/baskets';
import { TableState } from 'types/common';
import { GIVING_BASKETS } from 'utils/constants';

export type TabComponents = 'announcement' | 'baskets';
interface SetCurrentTabPayload {
    component: TabComponents;
    currentTab: AnnouncementsTabs | BasketsTabs;
}

interface AppState {
    announcement: Announcements;
    baskets: Baskets;
    table: TableState;
}

const tableInitialState = {
    pageNumber: 0,
    pageSize: defaultPageSize,
    offset: defaultOffset,
};

const initialState: AppState = {
    announcement: {
        currentTab: ANNOUNCEMENTS,
    },
    baskets: {
        currentTab: GIVING_BASKETS,
    },
    table: tableInitialState,
};

export const setAnnouncementsTab = (currentTab: AnnouncementsTabs) => (dispatch: AppDispatch) => {
    dispatch(
        setCurrentTab({
            component: 'announcement',
            currentTab,
        })
    );
};
export const setBasketsTab = (currentTab: BasketsTabs) => (dispatch: AppDispatch) => {
    dispatch(
        setCurrentTab({
            component: 'baskets',
            currentTab,
        })
    );
};

const appSlice = createSlice({
    name: 'appSlice',
    initialState,
    reducers: {
        setCurrentTab: (state, action: { payload: SetCurrentTabPayload }) => {
            const payload = action?.payload || {};
            if (!payload) return;
            const { component, currentTab } = payload;
            if (!component || !currentTab) return;
            if (component) state[component].currentTab = currentTab;
        },
        updateTableState: (state, action: { payload: TableState }) => {
            const { payload } = action;
            if (!payload) return;
            state.table = { ...state.table, ...payload };
        },
        resetTableState: (state) => {
            state.table = tableInitialState;
        },
    },
});

export const { setCurrentTab, updateTableState, resetTableState } = appSlice.actions;

export default appSlice.reducer;
